import moment from 'moment';
import { fnComparedValueAndCriterion } from 'utils/logProcessing';

export default function makeDataLevel(d, gasCriterion, pageIndex, pageSize, index) {


  return {
    rnum: pageIndex * pageSize + index + 1,
    areaNo: d.locationNo,
    areaNm: d.locationNm,
    modelNm: d.module.modelNm,
    temp: d.temp.toFixed(1),
    humi: d.humi,
    heatindex: d.heatindex.toFixed(1),
    statusCode: d.statusCode,
    status: fnComparedValueAndCriterion(d, d.module.moduleScn, gasCriterion)[0],
    battery: d.battery,
    regDate: moment(d.rgstDt).format('YYYY-MM-DD HH:mm:ss'),
  };
}
